import React, { useEffect, useState } from "react"
import MetaTags from 'react-meta-tags';
import {
  Button,
  Card,
  CardBody,
  Col,
  Container,
  Row,
  CardTitle,
  CardText,
  Spinner,
  Input,
  Modal,
  UncontrolledTooltip,
} from "reactstrap"
import { Link } from "react-router-dom"
import ToolkitProvider from "react-bootstrap-table2-toolkit"
import BootstrapTable from "react-bootstrap-table-next"
import { postAddDefaultUnits } from "helpers/backend_helper"
import { postAddDefaultTaxes } from "helpers/backend_helper"
import { postAddDefaultCOA } from "helpers/backend_helper"
import { postAddDefaultCOAccounts } from "helpers/backend_helper"
import { postAddDefaultSettings, postClearAllServerCache } from "helpers/backend_helper"
import {postImportItems} from "helpers/backend_helper"
import { addNewItemDirect as onAddItemDirect } from "helpers/backend_helper"
import { showSuccessToast } from "helpers/function_helper"

const AdminHome = props => {

  const [showLoading, setShowLoading] = useState(false)
  const [result, setResult] = useState()
  const [uploadFileName, setUploadFileName] = useState()
  const [modal_xlarge, setmodal_xlarge] = useState(false)
  const [products, setProducts] = useState([])
  const [missingCategory, setMissingCategory] = useState([])
  const [successFullyAddedItems, setSuccessFullyAddedItems] = useState([])

  const [missingSubCategory, setMissingSubCategory] = useState([])
  const [missingHSN, setMissingHSN] = useState([])
  const [missingManu, setMissingManu] = useState([])
  const [missingBrand, setMissingBrand] = useState([])
  const [validationOk, setValidationOk] = useState(true)

  function tog_xlarge() {
    setmodal_xlarge(!modal_xlarge)
    removeBodyCss()
  }

  useEffect(() => {
    if(products.length > 0){
      let tempMissingCategory = []
      let tempMissingSubCategory = []
      let tempMissingHSN = []
      let tempMissingManu = []
      let tempMissingBrand = []
      let tempvalidationOk = true
      products.forEach(each => {
        if(!each.productcode || each.productcode == '' || !each.productcategory || each.productcategory=='' 
        || !each.productunit || each.productunit =='' || !each.producttaxgroup || each.producttaxgroup == '' 
        || !each.baseprice || each.baseprice =='' || !each.mrp || each.mrp =='') {
          console.log('not ok for:',each)
          tempvalidationOk = false
        }
        if(!each.productcategoryid || each.productcategoryid==''){
          tempMissingCategory.push(each.productcategory)
        }

        if(!each.productsubcategoryid || each.productsubcategoryid==''){
          if(each.productsubcategory && each.productcategoryid && each.productsubcategory != ''){
            tempMissingSubCategory.push({
              category : each.productcategoryid,
              subCategory : each.productsubcategory
            })
          }
        }

        if(!each.producthsnid || each.producthsnid==''){
          if(each.producthsn && each.producthsn != '' && !tempMissingHSN.includes(each.producthsn))
          tempMissingHSN.push(each.producthsn)
        }
        if(!each.productmanufacturerid || each.productmanufacturerid==''){
          if(each.productmanufacturer && each.productmanufacturer != '' && !tempMissingManu.includes(each.productmanufacturer)){
            tempMissingManu.push(each.productmanufacturer)
          }
        }
        if(!each.productbrandid || each.productbrandid==''){
          if(each.productbrand && each.productbrand != '' && !tempMissingBrand.includes(each.productbrand)){
            tempMissingBrand.push(each.productbrand)
          }
        }
      })
      setMissingCategory(tempMissingCategory)
      setMissingSubCategory(tempMissingSubCategory)
      setMissingHSN(tempMissingHSN)
      setMissingManu(tempMissingManu)
      setMissingBrand(tempMissingBrand)
      console.log('tempMissingCategory:',tempMissingCategory)
      console.log('tempMissingSubCategory:',tempMissingSubCategory)
      console.log('tempMissingHSN:',tempMissingHSN)
      console.log('tempMissingManu:',tempMissingManu)
      console.log('tempMissingBrand:',tempMissingBrand)
      if(tempMissingCategory.length > 0  
        || tempMissingHSN.length > 0 || tempMissingManu.length > 0 || tempMissingBrand.length > 0 || !tempvalidationOk){
          setValidationOk(false)
        }

    }
    console.log('validation ok:',validationOk)
  }, [products])

  function removeBodyCss() {
    document.body.classList.add("no_padding")
  }

    async function loadUnits() {
      setShowLoading(true)
      setResult(null)
      const response =  await postAddDefaultUnits({})
      setResult(response)
      setShowLoading(false)
    }

    async function loadTaxes() {
      setShowLoading(true)
      setResult(null)
      const response =  await postAddDefaultTaxes({})
      setResult(response)
      setShowLoading(false)
    }

    async function loadMasterCOA() {
      setShowLoading(true)
      setResult(null)
      const response =  await postAddDefaultCOA({})
      setResult(response)
      setShowLoading(false)
    }

    async function loadCOA() {
      setShowLoading(true)
      setResult(null)
      const response =  await postAddDefaultCOAccounts({})
      setResult(response)
      setShowLoading(false)
    }

    async function loadSettings() {
      setShowLoading(true)
      setResult(null)
      const response =  await postAddDefaultSettings({})
      setResult(response)
      setShowLoading(false)
    }
    
    const uploadFileCallBack =  async (file) => {
      setShowLoading(true)
      const data = new FormData();
      /*
      files.map((file, index) => {
        data.append(`files`, file);
      });*/
      data.append(`files`, file);
      const response =  await postImportItems(data)
      //console.log('response:'+JSON.stringify(response))
      
      if(response.status == 'success'){
        setmodal_xlarge(true)
        //return response.url
        setShowLoading(false)
        //console.log('response.products:'+JSON.stringify(response.products))
        setProducts(response.products)
        
      }
      else{
        //return ""
        alert(response.errorResponse)
        setShowLoading(false)
      }
    }
  
    function uploadFile(){
      if(uploadFileName && uploadFileName != ''){
        uploadFileCallBack(uploadFileName)
      }
    }

    async function addCategory(categoryName) {
      setShowLoading(true)
      const response = await onAddItemDirect({
        'inputValue' : categoryName
      }, 'Category')
      setShowLoading(false)
      if(response.status == 'success'){
        let alreadyAddedItems = [...successFullyAddedItems]
        alreadyAddedItems.push(categoryName)
        setSuccessFullyAddedItems(alreadyAddedItems)
        uploadFile()
      }
      else if(response.status == 'failure'){

      }
    }

    async function addSubCategory(item) {
      setShowLoading(true)
      const response = await onAddItemDirect({
        'inputKey': item.category,
        'inputValue' : item.subCategory
      }, 'SubCategory')
      setShowLoading(false)
      if(response.status == 'success'){
        let alreadyAddedItems = [...successFullyAddedItems]
        alreadyAddedItems.push(item.subCategory)
        setSuccessFullyAddedItems(alreadyAddedItems)
        uploadFile()
      }
      else if(response.status == 'failure'){

      }
    }

    async function addHSN(name) {
      setShowLoading(true)
      const response = await onAddItemDirect({
        'inputKey': name,
      }, 'HSN')
      setShowLoading(false)
      if(response.status == 'success'){
        let alreadyAddedItems = [...successFullyAddedItems]
        alreadyAddedItems.push(name)
        setSuccessFullyAddedItems(alreadyAddedItems)
        uploadFile()
      }
      else if(response.status == 'failure'){

      }
    }

    async function addManufacturer(name) {
      setShowLoading(true)
      const response = await onAddItemDirect({
        'inputKey': name
      }, 'Manufacturer')
      setShowLoading(false)
      if(response.status == 'success'){
        let alreadyAddedItems = [...successFullyAddedItems]
        alreadyAddedItems.push(name)
        setSuccessFullyAddedItems(alreadyAddedItems)
        uploadFile()
      }
      else if(response.status == 'failure'){

      }
    }

    async function addBrand(name) {
      setShowLoading(true)
      const response = await onAddItemDirect({
        'inputKey': name,
      }, 'Brand')
      setShowLoading(false)
      if(response.status == 'success'){
        let alreadyAddedItems = [...successFullyAddedItems]
        alreadyAddedItems.push(name)
        setSuccessFullyAddedItems(alreadyAddedItems)
        uploadFile()
      }
      else if(response.status == 'failure'){

      }
    }

    async function clearServerCache() {
      setShowLoading(true)
      const response = await postClearAllServerCache({})
      setShowLoading(false)
      if(response.status == 'success'){
        showSuccessToast('Cleared Successfully')
      }
      else if(response.status == 'failure'){

      }
    }

    

    async function confirmImport() {
      setShowLoading(true)
      const response = await onAddItemDirect(products, 'ConfirmImport')
      setShowLoading(false)
      if(response.status == 'success'){
        showSuccessToast('Imported Successfully!!!')
        setmodal_xlarge(false)
        //console.log('status..:'+response.status)
      }
      else if(response.status == 'failure'){

      }
    }

    const productColumns = () => [
      {
        dataField: "productcode",
        text: "Product Code",
        sort: true,
        formatter: (cellContent, row) => (
          <span className=" ">
            {cellContent == '' ? <div className="text-danger">Missing</div>:<div>{cellContent}</div>}
          </span>
        ),
      },
      {
        dataField: "productname",
        text: "Name",
        sort: true,
        formatter: (cellContent, row) => (
          <span className=" ">
            {cellContent == '' ? <div className="text-danger">Missing</div>:<div>{cellContent}</div>}
          </span>
        ),
      },
      {
        dataField: "productcategory",
        text: "Category",
        sort: true,
        formatter: (cellContent, row) => (
          <span className=" ">
            {cellContent == '' ? <div className="text-danger">Missing</div>:<div>{cellContent}</div>}
            {cellContent == '' || row.productcategoryid ? <span></span>:<span className="text-info">(new)</span>}
          </span>
        ),
      },
      {
        dataField: "productsubcategory",
        text: "Sub-Category",
        sort: true,
        formatter: (cellContent, row) => (
          <span className=" ">
            {cellContent}
            {cellContent == '' || row.productsubcategoryid ? <span></span>:<span className="text-info">(new)</span>}
          </span>
        ),
      },
      {
        dataField: "producthsn",
        text: "HSN",
        sort: true,
        formatter: (cellContent, row) => (
          <span className=" ">
            {cellContent == '' ? <div className="text-danger">Missing</div>:<div>{cellContent}</div>}
            {cellContent != '' && row.producthsnid ? <span></span>:<span className="text-info">(new)</span>}
          </span>
        ),
      },
      {
        dataField: "productunit",
        text: "Unit",
        sort: true,
        formatter: (cellContent, row) => (
          <span className=" ">
            {cellContent == '' ? <div className="text-danger">Missing</div>:<div>{cellContent}</div>}
            {cellContent != '' && row.productunitid ? <span></span>:<span className="text-info">(new)</span>}
          </span>
        ),
      },
      {
        dataField: "productmanufacturer",
        text: "Manufacturer",
        sort: true,
        formatter: (cellContent, row) => (
          <span className=" ">
            {cellContent}
            {cellContent == '' || row.productmanufacturerid ? <span></span>:<span className="text-info">(new)</span>}
          </span>
        ),
      },
      {
        dataField: "producttaxgroup",
        text: "GST",
        sort: true,
        formatter: (cellContent, row) => (
          <span className=" ">
            {cellContent == '' ? <div className="text-danger">Missing</div>:<div>{cellContent}</div>}
            {cellContent != '' && row.producttaxgroupid ? <span></span>:<span className="text-info">(new)</span>}
          </span>
        ),
      },
      {
        dataField: "productsupplier",
        text: "Supplier",
        sort: true,
        formatter: (cellContent, row) => (
          <span className=" ">
            {cellContent}
            {cellContent == '' || row.productsupplierid ? <span></span>:<span className="text-info">(new)</span>}
          </span>
        ),
      },
      {
        dataField: "productbrand",
        text: "Brand",
        sort: true,
        formatter: (cellContent, row) => (
          <span className=" ">
            {cellContent}
            {cellContent == '' || row.productbrandid ? <span></span>:<span className="text-info">(new)</span>}
          </span>
        ),
      },
      {
        dataField: "stockalertlevel",
        text: "Stock",
        sort: true,
      },
      {
        dataField: "baseprice",
        text: "P.Rate",
        sort: true,
        formatter: (cellContent, row) => (
          <span className=" ">
            {cellContent == '' ? <div className="text-danger">Missing</div>:<div>{cellContent}</div>}
          </span>
        ),
      },
      {
        dataField: "mrp",
        text: "MRP",
        sort: true,
        formatter: (cellContent, row) => (
          <span className=" ">
            {cellContent == '' ? <div className="text-danger">Missing</div>:<div>{cellContent}</div>}
          </span>
        ),
      },
      {
        dataField: "retailprice",
        text: "Retail",
        sort: true,
      },
      {
        dataField: "wholesaleprice",
        text: "W.Sale",
        sort: true,
      }
    ]

    return (
      <React.Fragment>
        <div className="page-content">
          <MetaTags>
            <title>Admin | Flamingo</title>
          </MetaTags>
          <Container fluid>
            <h4>Admin Home</h4>
            {result && <Row>
              <Col lg={12}>
                <Card>
                <h5 className="card-header border-bottom text-uppercase">{result.status}</h5>
                <CardBody>
                  <CardText>
                    {result.response}
                  </CardText>
                </CardBody>
                </Card>
              </Col>
            </Row>}
            <Row>
              <Col lg={4}>
                <Card>
                  <h5 className="card-header bg-transparent border-bottom text-uppercase">COA - Master </h5>
                  <CardBody>
                    <CardTitle className="mt-0">
                      Load Master COA
                    </CardTitle>
                    <CardText>
                    Load Master COA Accounts
                    </CardText>
                    <Link to="#" className="btn btn-primary"
                      onClick={() => {
                        loadMasterCOA()
                      }}
                    >
                      Load
                    </Link>
                    {showLoading && <Spinner style={{ width: '2.2rem', height: '2.2rem' }} className="ms-3" color="primary" />}
                  </CardBody>
                </Card>
              </Col>
              <Col lg={4}>
                <Card>
                  <h5 className="card-header bg-transparent border-bottom text-uppercase">COA</h5>
                  <CardBody>
                    <CardTitle className="mt-0">
                      Load COA
                    </CardTitle>
                    <CardText>
                    Load COA Accounts
                    </CardText>
                    <Link to="#" className="btn btn-primary"
                      onClick={() => {
                        loadCOA()
                      }}
                    >
                      Load
                    </Link>
                    {showLoading && <Spinner style={{ width: '2.2rem', height: '2.2rem' }} className="ms-3" color="primary" />}
                  </CardBody>
                </Card>
              </Col>

              <Col lg={4}>
                <Card>
                  <h5 className="card-header bg-transparent border-bottom text-uppercase">Settings</h5>
                  <CardBody>
                    <CardTitle className="mt-0">
                      Load Settings
                    </CardTitle>
                    <CardText>
                      Load Global Settings
                    </CardText>
                    
                    <Link to="#" className="btn btn-primary"
                    
                      onClick={() => {
                        loadSettings()
                      }}
                    >
                      Load
                    </Link>
                    {showLoading && <Spinner style={{ width: '2.2rem', height: '2.2rem' }} className="ms-3 " color="primary" />}
                  </CardBody>
                </Card>
              </Col>
              
            </Row>
            <Row>
              <Col lg={4}>
                <Card>
                  <h5 className="card-header bg-transparent border-bottom text-uppercase">Unit</h5>
                  <CardBody>
                    <CardTitle className="mt-0">
                      Load Units
                    </CardTitle>
                    <CardText>
                      Load default units
                    </CardText>
                    
                    <Link to="#" className="btn btn-primary"
                    
                      onClick={() => {
                        loadUnits()
                      }}
                    >
                      Load
                    </Link>
                    {showLoading && <Spinner style={{ width: '2.2rem', height: '2.2rem' }} className="ms-3 " color="primary" />}
                  </CardBody>
                </Card>
              </Col>

              <Col lg={4}>
                <Card>
                  <h5 className="card-header bg-transparent border-bottom text-uppercase">Tax</h5>
                  <CardBody>
                    <CardTitle className="mt-0">
                      Load Taxes
                    </CardTitle>
                    <CardText>
                      Load default taxes
                    </CardText>
                    <Link to="#" className="btn btn-primary"
                      onClick={() => {
                        loadTaxes()
                      }}
                    >
                      Load
                    </Link>
                    {showLoading && <Spinner style={{ width: '2.2rem', height: '2.2rem' }} className="ms-3 " color="primary" />}
                  </CardBody>
                </Card>
              </Col>

              <Col lg={4}>
                <Card>
                  <h5 className="card-header bg-transparent border-bottom text-uppercase">Import Products</h5>
                  <CardBody>
                    <CardTitle className="mt-0">
                      Select Excel 
                    </CardTitle>
                    <CardText>
                      <>
                      <span className="input-group">
                        <Input type="file" className="form-control" id="inputGroupFile04" aria-describedby="inputGroupFileAddon04" aria-label="Upload" 
                        onChange={e => {
                          setUploadFileName(e.target.files[0])
                        }}
                        />
                        <button className="btn btn-primary" type="button" id="inputGroupFileAddon04"
                        onClick={()=> uploadFile()}>
                          Upload
                        </button>
                      </span>
                      </>
                    </CardText>
                    
                    {showLoading && <Spinner style={{ width: '2.2rem', height: '2.2rem' }} className="ms-3 " color="primary" />}
                  </CardBody>
                </Card>
              </Col>
              

            </Row>
            <Row>
              <Col lg={4}>
                <Card>
                  <h5 className="card-header bg-transparent border-bottom text-uppercase">Clear Cache</h5>
                  <CardBody>
                    <CardTitle className="mt-0">
                      Clear Server Cache
                    </CardTitle>
                    <CardText>
                    Clear Cache
                    </CardText>
                    <Link to="#" className="btn btn-primary"
                      onClick={() => {
                        clearServerCache()
                      }}
                    >
                      Clear
                    </Link>
                    {showLoading && <Spinner style={{ width: '2.2rem', height: '2.2rem' }} className="ms-3 " color="primary" />}
                  </CardBody>
                </Card>
              </Col>
            </Row>

            <Modal
                size="xl"
                isOpen={modal_xlarge}
                toggle={() => {
                  tog_xlarge()
                }}
              >
                <div className="modal-header">
                  <h5
                    className="modal-title mt-0"
                    id="myExtraLargeModalLabel"
                  >
                    Products
                      </h5>
                  <button
                    onClick={() => {
                      setmodal_xlarge(false)
                    }}
                    type="button"
                    className="close"
                    data-dismiss="modal"
                    aria-label="Close"
                  >
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>
                <div className="modal-body">

                  {missingCategory.length > 0 && <div>
                    <Row className="ms-2 fw-bold pb-2">
                      Missing Categories
                    </Row>
                    {(missingCategory || []).map((category, key) => (
                      <Row key={key} className="ms-2 pb-2">
                        <Col lg="3">
                          {category}
                        </Col>
                        {!successFullyAddedItems.includes(category) && 
                        <Col lg="2" className="">
                            <Button
                                color="info"
                                className="btn-sm btn-info ms-2 me-2  d-inline-item"
                                disabled={showLoading}
                                onClick={() => {
                                addCategory(category)
                                }}
                              >
                                Add
                                {(showLoading) && <Spinner style={{ width: '0.8rem', height: '0.8rem' }} className="ms-1"  />}
                            </Button>
                        </Col>
                        }
                      </Row>
                    ))}
                  </div>
                  }

                  {missingSubCategory.length > 0 && <div>
                    <Row className="ms-2 fw-bold pb-2">
                      Missing Sub Categories
                    </Row>
                    {(missingSubCategory || []).map((item, key) => (
                      <Row key={key} className="ms-2 pb-2">
                        <Col lg="3">
                          {item.subCategory}
                        </Col>
                        {!successFullyAddedItems.includes(item.subCategory) && 
                        <Col lg="2" className="">
                            <Button
                                color="info"
                                className="btn-sm btn-info ms-2 me-2  d-inline-item"
                                disabled={showLoading}
                                onClick={() => {
                                addSubCategory(item)
                                }}
                              >
                                Add
                                {(showLoading) && <Spinner style={{ width: '0.8rem', height: '0.8rem' }} className="ms-1"  />}
                            </Button>
                        </Col>
                        }
                      </Row>
                    ))}
                  </div>
                  }

                  {missingHSN.length > 0 && <div>
                    <Row className="ms-2 fw-bold pb-2">
                      Missing HSN
                    </Row>
                    {(missingHSN || []).map((item, key) => (
                      <Row key={key} className="ms-2 pb-2">
                        <Col lg="3">
                          {item}
                        </Col>
                        {!successFullyAddedItems.includes(item) && 
                        <Col lg="2" className="">
                            <Button
                                color="info"
                                className="btn-sm btn-info ms-2 me-2  d-inline-item"
                                disabled={showLoading}
                                onClick={() => {
                                addHSN(item)
                                }}
                              >
                                Add
                                {(showLoading) && <Spinner style={{ width: '0.8rem', height: '0.8rem' }} className="ms-1"  />}
                            </Button>
                        </Col>
                        }
                      </Row>
                    ))}
                  </div>
                  }

                  {missingManu.length > 0 && <div>
                    <Row className="ms-2 fw-bold pb-2">
                      Missing Manufacturer
                    </Row>
                    {(missingManu || []).map((item, key) => (
                      <Row key={key} className="ms-2 pb-2">
                        <Col lg="3">
                          {item}
                        </Col>
                        {!successFullyAddedItems.includes(item) && 
                        <Col lg="2" className="">
                            <Button
                                color="info"
                                className="btn-sm btn-info ms-2 me-2  d-inline-item"
                                disabled={showLoading}
                                onClick={() => {
                                addManufacturer(item)
                                }}
                              >
                                Add
                                {(showLoading) && <Spinner style={{ width: '0.8rem', height: '0.8rem' }} className="ms-1"  />}
                            </Button>
                        </Col>
                        }
                      </Row>
                    ))}
                  </div>
                  }

                {missingBrand.length > 0 && <div>
                    <Row className="ms-2 fw-bold pb-2">
                      Missing Brand
                    </Row>
                    {(missingBrand || []).map((item, key) => (
                      <Row key={key} className="ms-2 pb-2">
                        <Col lg="3">
                          {item}
                        </Col>
                        {!successFullyAddedItems.includes(item) && 
                        <Col lg="2" className="">
                            <Button
                                color="info"
                                className="btn-sm btn-info ms-2 me-2  d-inline-item"
                                disabled={showLoading}
                                onClick={() => {
                                addBrand(item)
                                }}
                              >
                                Add
                                {(showLoading) && <Spinner style={{ width: '0.8rem', height: '0.8rem' }} className="ms-1"  />}
                            </Button>
                        </Col>
                        }
                      </Row>
                    ))}
                  </div>
                  }

                  <ToolkitProvider
                    keyField="productcode"
                    data={products || []}
                    columns={productColumns()}
                    bootstrap4
                  >
                    {toolkitProps => (
                      <React.Fragment>
                        <Row>
                          <Col xl="12">
                            <div className="table-responsive">
                              <BootstrapTable
                                responsive
                                remote
                                keyField="productcode"
                                bordered={false}
                                striped={false}
                                classes={
                                  "table align-middle table-nowrap table-hover"
                                }
                                {...toolkitProps.baseProps}
                              />
                            </div>
                          </Col>
                        </Row>
                      </React.Fragment>
                    )}
                  </ToolkitProvider>
                  {validationOk && <Row>
                    <Col>
                      <Button
                          color="info"
                          className="btn btn-info ms-2 me-2  d-inline-item"
                          disabled={showLoading}
                          onClick={() => {
                          confirmImport()
                          }}
                        >
                          Confirm Upload
                          {(showLoading) && <Spinner style={{ width: '0.8rem', height: '0.8rem' }} className="ms-1"  />}
                      </Button>
                    </Col>
                  </Row>
                  }
                </div>
              </Modal>
          </Container>
        </div>
      </React.Fragment>
    )
  
}

export default AdminHome;
